// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"JE-z","smallCardRow":"KE-z","largeCardRow":"LE-z","productSearchRow":"ME-z","curatedRow":"NE-z"};